import { render, staticRenderFns } from "./seleExamFirst.vue?vue&type=template&id=237ef516&scoped=true&"
import script from "./seleExamFirst.vue?vue&type=script&lang=js&"
export * from "./seleExamFirst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237ef516",
  null
  
)

export default component.exports